export default "/static/baton/app/dist/88591a33d733b344a8e33e799a8626d1.ttf";